<template>
    <h2 class="tw-text-sm sm:tw-text-base tw-font-medium tw-text-dark tw-font-title">
        <slot />
    </h2>
</template>

<script setup lang="ts">

</script>

<style scoped>

</style>
